import {ComponentProps, useMemo} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {getRandomConsultant} from "../../lead/utils/get_random_consultant";

interface IProps extends ComponentProps<"div"> {
    className?: string;
}

export const ConsultantBox = ({className, ...props}: IProps) => {
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <div className={cx(consultantBox, className)} {...props}>
            <Image imageClassName={css({borderRadius: "100%"})} width="44" height="44" src={consultant.image.s72} alt={consultant.fullName} />

            <div>
                <Text variant="body_copy_2" className={css({textWrap: "nowrap"})}>
                    {consultant.fullName}
                </Text>
                <Text variant="info_txt_2" color="var(--colors-gray-700)">
                    Konsultant rynekpierwotny.pl
                </Text>
            </div>
        </div>
    );
};

const consultantBox = css({
    borderRadius: 1,
    border: "1px solid var(--colors-gray-600)",
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
    padding: 1,
    minWidth: 234
});
import {ComponentProps, useMemo} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {getRandomConsultant} from "../../lead/utils/get_random_consultant";

interface IProps extends ComponentProps<"div"> {
    className?: string;
}

export const ConsultantBox = ({className, ...props}: IProps) => {
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <div className={cx(consultantBox, className)} {...props}>
            <Image imageClassName={css({borderRadius: "100%"})} width="44" height="44" src={consultant.image.s72} alt={consultant.fullName} />

            <div>
                <Text variant="body_copy_2" className={css({textWrap: "nowrap"})}>
                    {consultant.fullName}
                </Text>
                <Text variant="info_txt_2" color="var(--colors-gray-700)">
                    Konsultant rynekpierwotny.pl
                </Text>
            </div>
        </div>
    );
};

const consultantBox = css({
    borderRadius: 1,
    border: "1px solid var(--colors-gray-600)",
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
    padding: 1,
    minWidth: 234
});
